import React from 'react';
import Header from '../header/header';
import Footer from '../footer/footer';
import ImageSliderEtapes from './carrousseletapes';
import PaysagisteGallery from './paysagistegallery';

const Paysagiste = (props) => {
  return (
    <div>
          <Header />

    <div id="activites">

      <div className="container">
        <div>
                     <div className="col-xs-12 col-md-12">

            {" "}
 <br></br>
 <br></br>

            <div className="section-title">

      <h2 className='h2paysagiste'>Aménagement et entretien paysager</h2>
 <br></br>

                          <br></br>
                          <br></br>

      <p>
        Je vous accompagne dans tous vos projets d’aménagement et d’entretien paysager en Île-de-France.
        <br></br> Avec une approche sensible, artistique et profondément humaine, je transforme vos espaces extérieurs en véritables lieux de vie, de bien-être et d’émotion.
      </p>

      <p>
        Particuliers, entreprises ou collectivités, bénéficiez d’un savoir-faire complet pour la création et l’entretien de vos espaces verts. 
        <br></br>
        Mes jardins sont conçus comme de véritables œuvres vivantes, où nature et esthétisme s’accordent en parfaite harmonie.
      </p>
 <br></br>
      <h3 style={{ color: "#a8bb48" }}>Conception paysagère sur mesure</h3>
       <br></br>
      <p>
        Je conçois des espaces extérieurs personnalisés adaptés à vos besoins : jardins, terrasses, massifs végétaux et aménagements paysagers.
      </p>
 <br></br>
      <h4 style={{ color: "#a8bb48" }}>Création et entretien d’espaces verts</h4>
      <ul className='lipaysagiste'>
        <li>Création de jardins et plantations</li>
        <li>Entretien régulier des espaces verts</li>
        <li>Remise en état de jardins avant événement</li>
      </ul>
 <br></br>
      <h4 style={{ color: "#a8bb48" }}>Entretien courant des jardins</h4>
 
      <ul className='lipaysagiste'>
        <li>Tonte de pelouse, arrosage et paillage</li>
        <li>Nettoyage des massifs et des allées</li>
      </ul>
 <br></br>
      <h4 style={{ color: "#a8bb48" }}>Taille et soin des végétaux</h4>
      <ul className='lipaysagiste'>
        <li>Taille de haies, d’arbustes et d’arbres</li>
        <li>Désherbage manuel ou écologique</li>
      </ul>
 <br></br>
      <h3 style={{ color: "#a8bb48" }}>Petite maçonnerie paysagère et aménagements</h3>
       <br></br>
      <p>
        Je réalise également des petits travaux de maçonnerie paysagère ainsi que la création de bassins naturels, afin d’apporter une dimension esthétique et durable à vos extérieurs.
      </p>

      <p>
        De la conception à la réalisation : croquis, préparation du sol, plantations, taille des végétaux et aménagements sur mesure. Je sublime vos jardins avec un regard artistique et naturel pour créer des espaces vivants et harmonieux.
      </p>

  

<p>
  En tant que paysagiste en Île-de-France, j’interviens à domicile pour la création et l’entretien de jardins sur mesure.
</p>
<br></br>

      <h3 style={{ color: "#a8bb48" }}>Exemple des différentes étapes de réalisation d'un projet paysager :</h3>


<ImageSliderEtapes />
<br></br>
<br></br>
<PaysagisteGallery />

          </div>

        </div>

      </div>
</div>
      </div>
      <Footer />

    </div>
  );
};
export default Paysagiste